import { Button, DialogActions, Grid } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./EditImages.css";
import { useUpdateImagesMutation } from "state/api";
import { toast } from "react-hot-toast";

const EditImages = (props) => {
  const { images, onClose, carId } = props;
  // images.append(thumbnail);
  const [updateImages] = useUpdateImagesMutation();
  const [selectedImages, setSelectedImages] = React.useState(images);
  const [Thumbnail, setThumbnail] = React.useState(null);
  const [isSubmitted, setisSubmitted] = React.useState(false);
  const [ToDelete, setToDelete] = React.useState([]);
  // const [ToAdd, setToAdd] = React.useState([]);
  const [Map, setMap] = React.useState({});
  function deleteHandler(image) {
    //Removing the image from the SelectedImages array
    setSelectedImages(selectedImages.filter((e) => e !== image));
    if (image.Added === true) {
      URL.revokeObjectURL(image.original);
      //Removing the entry of the image from the Map

      setMap((current) => {
        const copy = { ...current };
        delete copy[image.original];
        return copy;
      });
      // setToAdd((prev) => prev.filter((e) => e !== ToRemove));
    } else {
      setToDelete((prev) => prev.concat(image));
    }
  }
  const handleSubmit = () => {
    setisSubmitted(true);

    onClose();
  };
  React.useEffect(() => {
    if (isSubmitted) {
      async function sendData() {
        let arr = Object.values(Map);
        let delarr = [];
        let i = 0;
        for (i = 0; i < ToDelete.length; i++) {
          delarr.push(ToDelete[i].fid);
        }
        const tosendval = {
          ToAddImages: arr,
          ToDeleteImages: delarr,
          thumbnail: Map[Thumbnail?.original],
        };
        const body = new FormData();
        for (let i = 0; i < tosendval.ToDeleteImages.length; i++) {
          body.append("deletedImagesFid", tosendval.ToDeleteImages[i]);
        }
        for (let i = 0; i < tosendval.ToAddImages.length; i++) {
          body.append("image", tosendval.ToAddImages[i]);
        }
        if (tosendval.thumbnail !== undefined) {
          body.append("thumbnail", tosendval.thumbnail);
        } else {
          body.append("thumbnail", null);
        }
        body.append("id", carId);
        await updateImages(body)
          .unwrap()
          .then((res) => {
            toast.success("Images Updated");
          })
          .catch((err) => {
            toast.failure("Error in Updating Images");
          });

        // console.log(tosendval);
      }
      sendData();
    }
  }, [isSubmitted]);

  const onSelectFile = (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);
    const imagesArray = selectedFilesArray.map((file) => {
      let url = URL.createObjectURL(file);
      setMap((previousMap) => ({
        ...previousMap,
        [url]: file,
      }));
      //A map is created to store {url:file} mapping
      return { original: url, Added: true };
    });

    //Updating the selected Images
    setSelectedImages((previousImages) => previousImages.concat(imagesArray));
    // setToAdd((prev) => prev.concat(selectedFilesArray));
    //If only One image is selected then we should make it the Thumbnail
    // if (selectedImages.length === 0) {
    //   let thumb = imagesArray[0];
    //   setThumbnail(thumb);
    // }

    //For Bug in Chrome
    event.target.value = "";
  };
  return (
    <>
      <div
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: "190px",
        }}
      >
        <h1>Edit The Images</h1>
      </div>
      <Grid
        container
        direction="column"
        sx={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <section>
          <label className="LABEL">
            + Add Images
            <br />
            <span>(up to 8 images)</span>
            <input
              type="file"
              name="images"
              onChange={onSelectFile}
              multiple
              accept="image/png , image/jpeg, image/webp, image/jpg"
            />
          </label>

          <input type="file" multiple />

          {selectedImages.length > 0 &&
            (selectedImages.length > 8 ? (
              <p className="error">
                You can't upload more than 8 images! <br />
                <span>please delete them </span>
              </p>
            ) : (
              <></>
            ))}

          <div className="images">
            {selectedImages &&
              selectedImages.map((image, index) => {
                return (
                  <div key={image.original} className="image">
                    <img src={image.original} height="200" alt="upload" />
                    {Thumbnail != null &&
                    Thumbnail.original === image.original ? (
                      <></>
                    ) : (
                      <button
                        className="Deleter"
                        onClick={() => deleteHandler(image)}
                      >
                        <CloseIcon />
                      </button>
                    )}

                    {image.Added === true ? (
                      <>
                        {Thumbnail != null &&
                        Thumbnail.original === image.original ? (
                          <button
                            className="ThumbnailRemover"
                            onClick={() => setThumbnail(null)}
                          >
                            Remove Thumbnail
                          </button>
                        ) : (
                          <button
                            className="Thumbnailer"
                            onClick={() => setThumbnail(image)}
                          >
                            Make Thumbnail
                          </button>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    <br />
                    {/* {selectedImages.length <= 1 ? (
                      <></>
                    ) : (
                      <>
                        {Thumbnail.url === image.original ? (
                          <button
                            className="ThumbnailRemover"
                            onClick={() => setThumbnail(null)}
                          >
                            Remove Thumbnail
                          </button>
                        ) : (
                          <button
                            className="Thumbnailer"
                            onClick={() => setThumbnail(image)}
                          >
                            Make Thumbnail
                          </button>
                        )}
                      </>
                    )} */}
                  </div>
                );
              })}
          </div>
          {/* <Typography variant="caption">
            {errors.image && <p style={{ color: "red" }}>{errors.image}</p>}
          </Typography> */}
        </section>
        {/* flex with 2 buttons */}
      </Grid>
      <DialogActions>
        <div className="flex justify-end gap-2">
          <Button
            onClick={handleSubmit}
            // type="submit"

            className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
          >
            Submit
          </Button>
          <Button
            onClick={onClose}
            // type="submit"

            className="bg-[#3671D5] hover:bg-[#114AAA] text-white"
          >
            Close
          </Button>
        </div>
      </DialogActions>
    </>
  );
};

export default EditImages;
